module.exports = __webpack_public_path__ + "img/bg-login-e-cross.1e58808f.png";